import React from 'react';
import styles from "./loaderScreen.module.scss"
import ThreeDotsSpinner from '../ThreeDotsSpinner';


const LoaderScreen = ({textClassName = null, loaderColor='#cac9c9', open, text }) => {

    return (
        <>
            { open &&
                <div className={styles.loaderWrapper}>
                    <div className={`${textClassName || styles.description}`} style={{ "color": loaderColor}}>
                        {text}
                    </div>
                    <ThreeDotsSpinner color={loaderColor}/>                    
                </div>
            }
        </>
    )
}

export default (LoaderScreen);